import { render, staticRenderFns } from "./ManageFilesBatch.vue?vue&type=template&id=d5c126fc"
import script from "./ManageFilesBatch.vue?vue&type=script&lang=js"
export * from "./ManageFilesBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports